// extracted by mini-css-extract-plugin
module.exports = {"widget":"Youtube_widget__1FEGl"};